import {
  LineSegments,
  LineBasicMaterial,
  Float32BufferAttribute,
  BufferGeometry,
  Color,
} from "three";

class WireframedBox extends LineSegments {
  constructor(width = 10, height = 10, color = 0x444444) {
    color = new Color(color);

    const vertices = [],
      colors = [];

    for (let i = 0, j = 0, k = -height / 2; i <= height; i++, k += 1) {
      vertices.push(-width / 2, 0, k, width / 2, 0, k);
      color.toArray(colors, j);
      j += 3;
      color.toArray(colors, j);
      j += 3;
      color.toArray(colors, j);
      j += 3;
      color.toArray(colors, j);
      j += 3;
    }

    for (let i = 0, j = colors.length, k = -width / 2; i <= width; i++, k += 1) {
      vertices.push(k, 0, -height / 2, k, 0, height / 2);
      color.toArray(colors, j);
      j += 3;
      color.toArray(colors, j);
      j += 3;
      color.toArray(colors, j);
      j += 3;
      color.toArray(colors, j);
      j += 3;
    }

    const geometry = new BufferGeometry();
    geometry.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    geometry.setAttribute("color", new Float32BufferAttribute(colors, 3));

    const material = new LineBasicMaterial({
      vertexColors: true,
      toneMapped: false,
      lineWidth: 0.1
    });

    super(geometry, material);

    this.type = "WireframedBox";
  }
}

export { WireframedBox };
